import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MediaService, MEDIA_CATEGORIES } from '../../../services/media/media.service';
import { ToastService } from '../../../services/toast/toast.service';
import { LoaderComponent } from '../../../atoms/loader/loader.component';

// rename / recategorise one media item (the image itself is not replaced — upload a
// new one instead). Self-saving; closes with `true` on success. data = { media }.
@Component({
  selector: 'app-media-edit-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule, LoaderComponent],
  templateUrl: './media-edit-dialog.component.html',
  styleUrls: ['../media-upload-dialog/media-upload-dialog.component.scss', '../../../../common-style/ac-dialog.scss'],
})
export class MediaEditDialogComponent {
  form: FormGroup;
  isLoading: boolean = false;
  readonly categories = MEDIA_CATEGORIES;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<MediaEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { media: any },
    private mediaService: MediaService,
    private toastService: ToastService
  ) {
    this.form = this.fb.group({
      name: [data.media?.name || '', Validators.required],
      category: [data.media?.category || 'UTSAV', Validators.required],
      remarks: [data.media?.remarks || ''],
    });
  }

  submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.toastService.error('Name and category are required.');
      return;
    }
    const value = this.form.value;
    this.isLoading = true;
    this.mediaService
      .updateMedia(this.data.media.mediaId, {
        name: value.name.trim(),
        category: value.category,
        remarks: value.remarks?.trim() || undefined,
      })
      .subscribe({
        next: (res: any) => {
          this.toastService.success(res?.message || 'Media updated.');
          this.isLoading = false;
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.isLoading = false;
          this.toastService.error(err?.error?.message || 'Failed to update media.');
        },
      });
  }

  close(): void {
    this.dialogRef.close();
  }
}
